import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Router } from '@angular/router';
import { Tokens } from '../core/models/tokens';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly JWT_TOKEN = 'access_token';
  private readonly REFRESH_TOKEN = 'refresh_token';
  private readonly STATE = 'state';
  private loggedUser: string;

  constructor(private http: HttpClient,
    private router: Router) { }

  isLoggedIn() {
    console.log("isLoggedIn", !!this.getJwtToken())
    return !!this.getJwtToken();
  }

  refreshToken() {
    console.log("REFRESH")
    return this.http.post<any>(`${environment.API}${environment.URL_REFRESH_TOKEN}`, {
      'refreshToken': this.getRefreshToken()
    }).pipe(tap(tokens => {
      if (tokens.code == 200) {
        this.storeTokens(tokens.data);
      } else {
        this.router.navigate(["/error-page"], { queryParams: { state: this.getState(), errorCode: '00' } }).then(() => {
          localStorage.clear();
          window.location.reload();
        });
      }
    }));
  }

  getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }

  getState() {
    return localStorage.getItem(this.STATE);
  }

  private doLoginUser(username: string, tokens: Tokens) {
    this.loggedUser = username;
    this.storeTokens(tokens);
  }

  private doLogoutUser() {
    this.loggedUser = null;
    this.removeTokens();
  }

  public getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeJwtToken(jwt: string) {
    localStorage.setItem(this.JWT_TOKEN, jwt);
  }

  private storeTokens(tokens) {
    localStorage.setItem(this.JWT_TOKEN, tokens.access_token);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.refresh_token);
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
  }
}